import styled from "styled-components";
import Tooltip from "../../../base/others/tooltip/index.js";
import { FontMixin } from "../../../../styles/common/mixins/helpers.styled.js";
export const InfoDataProtection = styled.div.withConfig({
    displayName: "styled__InfoDataProtection",
    componentId: "sc-63ec866f-0"
})`
	${FontMixin({
    size: 'small',
    height: 'base',
    weight: 'light'
})}
	text-align: left;

	& > .content-info-data-protection {
		color: ${({ theme  })=>theme.colors.grays.darker};
	}

	& > .link-info-data-protection {
		color: ${({ theme  })=>theme.colors.grays.darker};
		cursor: pointer;
		margin: 0px 3px;
		text-decoration: underline;
	}
`;
export const DataProtectionTooltip = styled(Tooltip).withConfig({
    displayName: "styled__DataProtectionTooltip",
    componentId: "sc-63ec866f-1"
})`
	max-width: 350px;
	padding: 16px 20px;
`;
export const DataProtectionContentTooltip = styled.div.withConfig({
    displayName: "styled__DataProtectionContentTooltip",
    componentId: "sc-63ec866f-2"
})`
	${FontMixin({
    size: 'small',
    height: 'base',
    weight: 'light'
})}

	& > .title-data-protection {
		color: ${({ theme  })=>theme.colors.grays.darker};
		${FontMixin({
    size: 'medium',
    weight: 'medium'
})}
		margin-bottom: 4px;
	}

	& > .content-data-protection {
		color: ${({ theme  })=>theme.colors.grays.darker};
		display: inline;
	}

	& > .link-data-protection {
		color: ${({ theme  })=>theme.colors.primary.base};
		cursor: pointer;
		display: inline;
		text-decoration: underline;
	}
`;

//# sourceMappingURL=styled.js.map